import { InmarDisposition } from "./inmar-disposition";

export enum InmarDispositionAction {
  APPROVAL = "approval",
  REJECT = "reject",
  NOTHING = "nothing",
}

export const InmarDispositionActionDisplayText = {
  [InmarDispositionAction.APPROVAL]: "Approval",
  [InmarDispositionAction.REJECT]: "Reject",
  [InmarDispositionAction.NOTHING]: "No Action",
} as const;

export interface InmarCapturedResponseConfig {
  name: string;
  value: string;
  action: InmarDispositionAction;
  restock: boolean;
}

export interface InmarDispositionMapping {
  disposition: InmarDisposition;
  capturedResponses: InmarCapturedResponseConfig[];
  defaultAction: InmarDispositionAction;
  defaultRestock: boolean;
}
